import {Component, HostListener, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Asset, AssetProperties, AssetWithProperties} from "../asset.model";
import {AssetStateService} from '../asset.state.service';
import {Subscription} from 'rxjs';
import {AssetService} from '../asset.service';
import {Location, NgClass} from '@angular/common';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';
import {AddToCollectionComponent} from '../../add-to-collection/add-to-collection.component';
import {AssetFilter} from '../asset-filter';
import {TranslatePipe} from "@ngx-translate/core";
import {FullHeighDirective} from "../../common/full-heigh.directive";
import {HttpParams} from "@angular/common/http";
import {SnackBarService} from "../../common/snack-bar-service";
import {UserStateService} from "../../user/user.state.service";
import {User} from "../../user/user";
import {CollectionPermissions, ReadonlyPermission} from "../../collection/collection.model";
import {CollectionService} from "../../collection/collection.service";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {ByteToMbPipe} from "../../common/pipes/byte-to-mb.pipe";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AssetUploadProperty} from "../../upload/upload.model";
import {buildUploadPropertiesForm, calculateEligibleFormProperties} from "../../upload/upload-asset/upload-form-utils";
import {buildAssetProperties} from "../asset-utils";
import {UploadService} from "../../upload/upload.service";
import {AssetDetailFormfieldComponent} from "./asset-detail-formfield/asset-detail-formfield.component";
import {AssetDetailPropertyComponent} from "./asset-detail-property/asset-detail-property.component";
import {UploadProcess} from "../../upload/upload-process";
import {MatProgressBar} from "@angular/material/progress-bar";
import {DateLocalePipe} from "../../common/pipes/date-locale.pipe";
import {Line2BrPipe} from "../../common/pipes/line2-br.pipe";
import {MatTooltip} from "@angular/material/tooltip";
import {ConfirmData} from "../../common/confirm-data";
import {ConfirmComponent} from "../../common/confirme/confirm.component";
import {AssetAction} from "../../dam-header/action-bar/asset-action";
import {AddToCollectionResult} from "../../add-to-collection/add-to-collection-result";

@Component({
    selector: 'app-asset-detail',
    imports: [
        NgClass,
        MatIconButton,
        MatIcon,
        TranslatePipe,
        FullHeighDirective,
        MatButton,
        MatMenu,
        MatMenuTrigger,
        MatMenuItem,
        ByteToMbPipe,
        ReactiveFormsModule,
        AssetDetailFormfieldComponent,
        AssetDetailPropertyComponent,
        MatProgressBar,
        DateLocalePipe,
        Line2BrPipe,
        MatTooltip,
    ],
    templateUrl: './asset-detail.component.html',
    styleUrl: './asset-detail.component.scss'
})
export class AssetDetailComponent implements OnInit, OnDestroy {
    assetSubscription: Subscription | undefined;
    filterSubscription: Subscription | undefined;
    asset: Asset | undefined;
    assetId: string | undefined;
    assetFilter: AssetFilter | undefined;
    fullAsset: AssetWithProperties | undefined;
    displayAssetDetail = false;
    hasImage = true;
    isVideo = false;
    isPdf = false;
    pdfSourceUrl: string | null = null;
    currentSelectedAssetIndex: number | undefined;
    isCollectionAsset: boolean = false;
    collectionPermission: CollectionPermissions | undefined;
    readOnlyPermissions: ReadonlyPermission | undefined;
    blockArrowNavigation = false;

    editProperties = false;
    propertiesForm: FormGroup = new FormGroup({});
    properties: AssetUploadProperty[] = [];
    eligibleProperties: AssetUploadProperty[] = [];

    editBinary = false;
    editBinaryProgress = -1;

    constructor(private assetStateService: AssetStateService,
                private assetService: AssetService,
                private dialog: MatDialog,
                private location: Location,
                private snackbarService: SnackBarService,
                private renderer: Renderer2,
                private userStateService: UserStateService,
                private collectionService: CollectionService,
                private uploadService: UploadService
    ) {
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEsc(ev: KeyboardEvent) {
        this.close();
    }
    @HostListener('document:keydown.arrowleft', ['$event'])
    onLeft(ev: KeyboardEvent) {
        if (!this.editProperties && (this.currentSelectedAssetIndex || this.currentSelectedAssetIndex === 0)) {
            this.prevAsset();
        }
    }
    @HostListener('document:keydown.arrowright', ['$event'])
    onRight(ev: KeyboardEvent) {
        if (!this.editProperties && (this.currentSelectedAssetIndex || this.currentSelectedAssetIndex === 0)) {
            this.nextAsset();
        }
    }

    get assets(): Asset[] {
        return this.assetStateService.loadedAssets
    }

    get user(): User | null {
        return this.userStateService.user;
    }

    canEdit() {
        return (this.user && this.user.effectiveRoles.ROLE_ASSET_EDIT) || false;
    }

    isEditing() {
        return this.editProperties || this.editBinary;
    }

    ngOnInit() {
        this.filterSubscription = this.assetStateService.filter$.subscribe(filter => {
            if (filter) {
                this.assetFilter = filter;
                /* if (this.getParamForAsset(this.assetFilter)) {
                     this.isCollectionAsset = true;
                     this.loadCollectionForPermissions();
                 } else {
                     this.isCollectionAsset = false;
                 }*/
            }
        })
        this.assetSubscription = this.assetStateService.assetUuidFromQueryParam$.subscribe(assetId => {
            if (assetId) {
                this.assetId = assetId;
                this.currentSelectedAssetIndex = this.getAssetIndex(this.assetId);
                if (this.assetFilter) {
                    if (this.getParamForAsset(this.assetFilter)) {
                        this.isCollectionAsset = true;
                        this.loadCollectionForPermissions();
                    } else {
                        this.isCollectionAsset = false;
                    }
                }
                this.getAsset(this.assetId)
            } else {
                this.close()
            }
        })
    }

    getAssetIndex(uuid: string): number | undefined {
        if (this.assets) {
            for (let i = 0; i < this.assets.length; i++) {
                if (this.assets[i].uuid === uuid) {
                    return i;
                }
            }
            return undefined
        }
        return undefined
    }

    getAsset(uuid: string) {
        if (this.assetFilter) {
            const params: HttpParams | undefined = this.getParamForAsset(this.assetFilter);
            this.assetService.getAsset(uuid, params).subscribe(asset => {
                this.fullAsset = asset;
                this.hasImage = true;
                if (this.fullAsset && this.fullAsset.assetBinary) {
                    const mimeType = this.fullAsset.assetBinary.mimetype;
                    this.isVideo = !!(mimeType && mimeType.startsWith('video/'));
                }
                if (this.fullAsset && this.fullAsset.assetLinks) {
                    if (this.fullAsset.assetLinks.pdfSourceUrl) {
                        this.isPdf = true;
                        this.pdfSourceUrl = this.fullAsset.assetLinks.pdfSourceUrl;
                    }
                }
                this.displayAssetDetail = true;
            })
        }
    }

    loadCollectionForPermissions() {
        if (this.assetFilter) {
            if (this.assetFilter.collectionUuid) {
               // console.log('normal collection')
                this.collectionService.getCollection(this.assetFilter.collectionUuid).subscribe(res => {

                   // console.log(this.isCollectionAsset)
                    this.collectionPermission = res.permissions;
                   // console.log('permissions?', this.collectionPermission);
                   // console.log('canDownLoad?', this.collectionPermission.canDownload);
                })
            }
            if (this.assetFilter.collectionSharedUuid) {
                this.collectionService.getSharedCollection(this.assetFilter.collectionSharedUuid).subscribe(res => {
                    this.readOnlyPermissions = res.permission;
                })
            }
            if (this.assetFilter.collectionPublicUuid) {
                this.collectionService.getPublishedCollection(this.assetFilter.collectionPublicUuid).subscribe(res => {
                    this.readOnlyPermissions = res.permission;
                })

            }
        }
    }

    getParamForAsset(assetFilter: AssetFilter): HttpParams | undefined {
        let params = new HttpParams();
        if (assetFilter.collectionUuid) {
            params = params.set('collectionUuid', assetFilter.collectionUuid);
            return params;
        }
        if (assetFilter.collectionSharedUuid) {
            params = params.set('collectionSharedKey', assetFilter.collectionSharedUuid);
            return params;
        }
        if (assetFilter.collectionPublicUuid) {
            params = params.set('collectionPublicSlug', assetFilter.collectionPublicUuid);
            return params;
        }
        return undefined;
    }

    nextAsset() {
        if (this.displayAssetDetail  && !this.blockArrowNavigation) {
            if (this.currentSelectedAssetIndex || this.currentSelectedAssetIndex === 0) {
                if (this.currentSelectedAssetIndex + 1 < this.assets.length) {
                    this.currentSelectedAssetIndex += 1;
                } else {
                    this.currentSelectedAssetIndex = 0;
                }
                this.isVideo = false;
                this.isPdf = false;
                this.getNewAsset(this.assets[this.currentSelectedAssetIndex].uuid);
            }
        }
    }

    prevAsset() {
        if (this.displayAssetDetail  && !this.blockArrowNavigation) {
            if (this.currentSelectedAssetIndex || this.currentSelectedAssetIndex === 0) {
                if (this.currentSelectedAssetIndex - 1 > -1) {
                    this.currentSelectedAssetIndex -= 1;
                } else {
                    this.currentSelectedAssetIndex = this.assets.length - 1;
                }
                this.isVideo = false;
                this.isPdf = false;
                this.getNewAsset(this.assets[this.currentSelectedAssetIndex].uuid);
            }
        }

    }

    getNewAsset(id: string) {
       // console.log('getNewAsset', id);
        this.resetForm();
        const params = new HttpParams().append(
            'assetId', id
        );
        this.location.replaceState(
            location.pathname, params.toString()
        )
        /*if (this.fullAsset) {
            this.fullAsset.thumbnails.md = '';
        }*/
        this.assetStateService.assetUuidFromQueryParam = id;
    }

    toggleEdit(e: any) {
        this.editProperties = !this.editProperties;
        if (this.editProperties) {
            this.uploadService.getUploadProperties().subscribe({
                next: (uploadProperties) => {
                    this.properties = uploadProperties;
                    let assetProperties = buildAssetProperties(this.properties, this.fullAsset!!);
                    this.initForm(assetProperties);
                }
            });
        }
    }
    resetForm() {
        this.properties = [];
        this.eligibleProperties = [];
        if (this.propertiesForm) {
            this.propertiesForm.reset();
        }
    }

    private initForm(assetProperties: AssetProperties) {
        this.eligibleProperties = calculateEligibleFormProperties(this.properties, assetProperties);

        // disable all properties that are not eligible, to preserve the original structure
        //for (const p of this.properties) {
        //    p.isReadonly = !this.isEligible(p);
        //}


        this.propertiesForm = buildUploadPropertiesForm(this.eligibleProperties, assetProperties);
        this.propertiesForm.valueChanges.subscribe({
            next: (value) => {
                // if the form is updated within this callback it triggers an infinite recursion - therefore we build the form anew
                this.initForm(value);
            }
        });
    }

    getControl(prop: AssetUploadProperty): FormControl | null {
        let control = this.propertiesForm.get(prop.name);
        if (!control) {
            return null;
        }
        return <FormControl<any>>control
    }

    isEligible(property: AssetUploadProperty): boolean {
        return this.eligibleProperties?.some(prop => prop.name === property.name) ?? false;
    }
    openPdf(url: string | null) {
        this.assetStateService.pdfSource = url;
    }

    close(): void {
        this.isVideo = false;
        this.isPdf = false;
        this.blockArrowNavigation = false;        //this.displayAssetDetail = false;
        this.location.replaceState(
            location.pathname, undefined
        )
        this.fullAsset = undefined;
        this.displayAssetDetail = false;
        this.editProperties = false;
        this.resetForm();
    }

    addToCollection(e: any) {
        if (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (this.fullAsset) {
            const asset: Asset = {
                classes: [],
                createdAt: this.fullAsset.createdAt,
                createdby: this.fullAsset.createdby,
                debugId: this.fullAsset.debugId,
                sapAttributes: this.fullAsset.sapAttributes,
                selected: this.fullAsset.selected,
                skus: this.fullAsset.skus,
                thumbnails: this.fullAsset.thumbnails,
                title: this.fullAsset.title,
                updatedAt: this.fullAsset.updatedAt,
                assetBinary: this.fullAsset.assetBinary,
                uuid: this.fullAsset.uuid,
                assetLinks: this.fullAsset.assetLinks,
                tags: this.fullAsset.tags,
            }
            const assets: Asset[] = [asset];
            this.startAddToCollectionFlow(assets);
        }

    }

    shareAsset(e: any) {
        if (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (this.fullAsset) {
            const asset: Asset = {
                classes: [],
                createdAt: this.fullAsset.createdAt,
                createdby: this.fullAsset.createdby,
                debugId: this.fullAsset.debugId,
                sapAttributes: this.fullAsset.sapAttributes,
                selected: this.fullAsset.selected,
                skus: this.fullAsset.skus,
                thumbnails: this.fullAsset.thumbnails,
                title: this.fullAsset.title,
                updatedAt: this.fullAsset.updatedAt,
                assetBinary: this.fullAsset.assetBinary,
                uuid: this.fullAsset.uuid,
                assetLinks: this.fullAsset.assetLinks,
                tags: this.fullAsset.tags,
            }
            this.blockArrowNavigation = true;
            const assets: Asset[] = [asset];
            this.dialog.open(AddToCollectionComponent, {
                width: '600px',
                data: {
                    assets,
                    initNew: true
                }
            }).afterClosed().subscribe((value: AddToCollectionResult) => {
                if (value) {
                    // console.log('successfully added to collection');
                    if (value.created) {
                        this.snackbarService.showMessage({
                            message: 'collection.created.success',
                            success: true
                        })
                    } else {
                        this.snackbarService.showMessage({
                            message: 'addedToCollection_success',
                            success: true
                        })
                    }
                }
                this.blockArrowNavigation = false;
            });
        }
    }

    private startAddToCollectionFlow(assets: Asset[]) {

        this.blockArrowNavigation = true;
        this.dialog.open(AddToCollectionComponent, {
            width: '600px',
            autoFocus: false,
            data: {
                assets
            }
        }).afterClosed().subscribe(value => {
            if (value) {
                if (value.created) {
                    this.snackbarService.showMessage({
                        message: 'collection.created.success',
                        success: true
                    })
                } else {
                    this.snackbarService.showMessage({
                        message: 'addedToCollection_success',
                        success: true
                    })
                }
            }
            this.blockArrowNavigation = false;
        });
    }

    canDownload(): boolean {
        if (this.user && this.user.effectiveRoles.ROLE_ASSET_DOWNLOAD) {
            return true;
        } else if (this.isCollectionAsset) {
            return this.collectionPermission?.canDownload || this.readOnlyPermissions === 'download';
        } else {
            return false;
        }
    }
    deleteAssets() {
            this.blockArrowNavigation = true;
            const mess: ConfirmData = {
                headline: "Delete.assets.hl",
                mess1: 'Delete.assets.mess1',
                mess2: '',
                mess3: '',
                btnText: 'button.deleteAssets',
            }
            const ref = this.dialog.open(ConfirmComponent, {
                data: mess,
                width: '800px',
                autoFocus: false,
            });
            ref.afterClosed().subscribe(result => {
                if (result) {
                    this.doDeleteAssets();
                }
                this.blockArrowNavigation = false;
            })

    }
    doDeleteAssets() {
            const uuids: string[] = [];
            if (this.fullAsset) {
                uuids.push(this.fullAsset.uuid);
            }
            this.assetService.deleteAssets(uuids).subscribe(() => {
                // this.reloadAssets();
                this.assetStateService.assetAction = AssetAction.reloadAssets;
                this.close()
            })
    }

    copyValue(txt: string) {
        // console.log('should copy', txt);
        navigator.clipboard.writeText(txt).then(() => {
            // console.log('Copied to clipboard');
        })
    }

    startDownload() {
        if (this.fullAsset && this.assetFilter) {
            const params: HttpParams | undefined = this.getParamForAsset(this.assetFilter);
            this.assetService.downloadAsset(this.fullAsset.uuid, params).subscribe(res => {
                if (res && res.data) {
                    const link = this.renderer.createElement('a');
                    link.setAttribute('target', '_blank');
                    link.setAttribute('href', res.data.url);
                    link.setAttribute('download', res.data.filename);
                    link.click();
                    link.remove();
                }
            })

        }

    }

    saveProperties() {
        this.uploadService.updateUpload([
            {
                uuid: this.fullAsset?.uuid!!,
                ...this.propertiesForm.value
            }
        ]).subscribe({
            next: (asset) => {
               // console.log('updated asset', asset);
                this.snackbarService.showMessage({
                    message: 'asset.update.success',
                    success: true
                });
                this.editProperties = false;
                this.resetForm();
                this.fullAsset = asset[0];
            }
        })
    }

    replaceBinary($event: Event) {
        let target = $event.target as HTMLInputElement;
        let files = target.files;
        if (files === null) {
           // console.warn('no files in event', $event);
            return;
        }
        let theFile = files[0];
        if (theFile === null) {
           // console.warn('file at index 0 is null');
        }

        this.editBinary = true;
        let upload = new UploadProcess(this.uploadService, theFile)
        upload.start();
        upload.$progress.subscribe({
            next: (progress) => {
                this.editBinaryProgress = progress;
            }
        })
        upload.$result.subscribe(res => {
            this.uploadService.updateUpload([{
                ...this.fullAsset,
                uuid: this.fullAsset?.uuid!!,
                tempBinary: {uuid: res.uuid}
            }]).subscribe({
                next: (asset) => {
                   // console.log('updated asset', asset);
                    this.snackbarService.showMessage({
                        message: 'asset.upload.success',
                        success: true
                    });
                    this.fullAsset = asset[0];
                },
                error: (error) => {
                   // console.error('error uploading', error);
                    this.snackbarService.showMessage({
                        message: 'asset.upload.error',
                        success: false
                    });
                },
                complete: () => {
                    this.editBinary = false;
                }
            })
        }, error => {
           // console.error('error uploading', error);
            this.snackbarService.showMessage({
                message: 'asset.upload.error',
                success: false
            });
            this.editBinary = false;
        });
    }

    ngOnDestroy() {
        if (this.assetSubscription) {
            this.assetSubscription.unsubscribe();
        }
        if (this.filterSubscription) {
            this.filterSubscription.unsubscribe();
        }
    }


    protected readonly Array = Array;
}
